import { Stack, Typography, InputAdornment, Box } from "@mui/material";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import AvatarComponent from "../../components/avatar";
import CustomTable from "../../components/customTable";
import CustomizedSnackbars from "../../components/snackbar";
import { useGetInflyxCreditListQuery } from "../../redux/api";
import { ROUTES } from "../../utils/routes";
import { CustomSearchInput } from "../../utils/constant";
import searchIcon from "../../assets/images/icons/searchIcon.svg";
import CustomPagination from "../../utils/CustomPagination";
import useDebounce from "../../hooks/use.debounce";

const CreditList = () => {
    const navigate = useNavigate();
    const [page, setPage] = useState(0);
    const [limit, setLimit] = useState(10);
    const [search, setSearch] = useState("");
    const debouncedSearch = useDebounce(search, 500);

    const { data, isLoading } = useGetInflyxCreditListQuery({
        limit,
        offset: page * limit,
        search: debouncedSearch
    });

    const [snackbar, setSnackbar] = React.useState({
        message: "",
        severity: "success",
        open: false,
    });

    const Action = (row) => {
        const { id } = row;
        return (
            <div className="actBtnGrps">
                <span className="viewIcon" onClick={() => navigate(`${ROUTES.REQUESTED_INFLYX_COINS}/details/${id}`)}>Edit</span>
            </div>
        );
    };

    const cols = [
        "photo",
        "name",
        "inflyxScore",
        "inflyxCoin",
    ];

    const tableData = [];
    if (data?.result?.list?.length) {
        for (const key of data.result.list) {
            tableData.push({
                photo: <AvatarComponent image={key.picture} />,
                name: key.name,
                id: key.influencerId,
                inflyxScore: key.inflyxScore !== null && key.inflyxScore !== undefined ? key.inflyxScore : "N/A",
                inflyxCoin: key.inflyxCoin,
            });
        }
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage - 1);
    };

    const handleChangeRowsPerPage = (event) => {
        setLimit(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleSearch = (e) => {
        setSearch(e.target.value);
        setPage(0);
    }

    const handleClearSearch = () => {
        setSearch("");
        setPage(0);
    }

    return (
        <>
            <CustomizedSnackbars msgData={snackbar} setMsgData={setSnackbar} style={{ maxWidth: '100%' }} />
            <Stack direction={"column"} gap={2}>
                <Stack
                    className="mainTitle flex-wrap"
                    direction={"row"}
                    alignItems={"center"}
                    justifyContent={"space-between"}
                    sx={{
                        minHeight: '42px',
                        padding: '0px 16px',
                    }}
                >
                    <Typography className="page-title" variant="h1">
                        Credit List View
                    </Typography>
                    <Stack direction={"row"} gap={2}>
                        <CustomSearchInput
                            className="inputSearch sContrl p-0"
                            value={search}
                            placeholder={"Search here..."}
                            handleSearch={handleSearch}
                            clearSearch={handleClearSearch}
                            startAdornment={
                                <InputAdornment style={{ borderRadius: '50px !important' }} className="overIcon" position="start"
                                    sx={{
                                        maxHeight: 'none',
                                        height: '38px',
                                        minWidth: '38px',
                                        marginRight: '0px', background: 'none !important', borderRadius: '50px !important'
                                    }}
                                >
                                    <img src={searchIcon} height={20} width={20} alt="" srcset="" />
                                </InputAdornment>
                            }
                        />
                    </Stack>
                </Stack>
                <Box sx={{ padding: '0px 16px' }}>

                    <Box
                        sx={{
                            backgroundColor: '#fff',
                            transition: 'all .5s ease-in-out',
                            position: 'relative',
                            border: '1px solid rgba(170, 170, 170, 0.3)',
                            borderRadius: '12px',
                            boxShadow: '0px 5px 5px 0px rgba(82, 63, 105, 0.05)',
                            overflow: 'hidden',

                        }}>
                        <CustomTable
                            cols={cols}
                            data={tableData}
                            isCheckbox={false}
                            actionComp={Action}
                            count={data?.result?.total || 0}
                            onPageChange={({ page, rows }) => {
                                setPage(page);
                                setLimit(rows);
                            }}
                        />
                    </Box>
                </Box>
            </Stack>
        </>
    );
};

export default CreditList;
